import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import {PropTypes} from 'prop-types';

import './ViewAllMetadata.scss';
import * as messageConstants from '../../../shared/messages';
import * as samlConstants from '../../../constants/samlConstants';
import ListOfParameters from "./ListOfParameters";

class ViewAllMetadata extends Component {
  static propTypes = {
    handleHideModalViewAllMetadata: PropTypes.func,
    showModalViewAllMetadata: PropTypes.any,
  }

  handleHideModalViewAllMetadata = () => {
    this.props.handleHideModalViewAllMetadata();
  }

  render() {
    return (
        <div>
          <Modal
              show={this.props.showModalViewAllMetadata}
              onHide={this.handleHideModalViewAllMetadata}
              container={this}
              dialogClassName="view-all-metadata-modal-width"
          >
            <Modal.Header
                className="basic-modal-header"
            >
              <Modal.Title>
                <span
                    className="basic-modal-header-title">{messageConstants.VIEW_ALL_METADATA}</span>
                <button className="entity-id-modal-close"
                        type="button"
                        onClick={this.handleHideModalViewAllMetadata}/>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {
                this.props.importedMetadata ?
                    (
                        <div className="view-metadata-entry-container">
                          <div
                              className="entry-label">{messageConstants.ENTITY_ID}</div>
                          <div
                              id="detailedSpMetadataEntityId"
                              className="entry-value">{this.props.importedMetadata.entityId}</div>
                          <div
                              className="entry-label">{messageConstants.AUTH_REQUEST_SIGNED}</div>
                          <div className="entry-value"
                               id="detailedSpMetadataAuthRequestSigned">
                            {this.props.importedMetadata.authRequestSigned
                                ? 'True' : 'False'}
                          </div>
                          <div
                              className="entry-label">{messageConstants.ASSERTION_SIGNED}</div>
                          <div className="entry-value"
                               id="detailedSpMetadataWantsAssertionSigned">
                            {this.props.importedMetadata.spWantsAssertionSigned
                                ? 'True' : 'False'}
                          </div>
                          <ListOfParameters
                              id="detailedSpMetadataPublicSignCertificates"
                              label={messageConstants.PUBLIC_SIGNED_KEY_CERTIFICATES}
                              list={this.props.importedMetadata.publicSigningKeyPemCertificates}
                              parameterName={samlConstants.PUBLIC_KEY_CERTIFICATE_INFO}
                              notSpecifiedText={messageConstants.NO_CERTIFICATES}
                          />

                          <ListOfParameters
                              id="detailedSpMetadataEncryptionCertificates"
                              label={messageConstants.ENCRYPTION_KEY_CERTIFICATES}
                              list={this.props.importedMetadata.publicEncryptionKeyPemCertificates}
                              parameterName={samlConstants.PUBLIC_KEY_CERTIFICATE_INFO}
                              notSpecifiedText={messageConstants.NO_CERTIFICATES}
                          />
                          <div className="entry-value"/>
                          <ListOfParameters
                              id="detailedSpMetadataNameIdValues"
                              label={messageConstants.NAME_ID_FORMAT}
                              list={this.props.importedMetadata.samlNameIdFormats}
                              parameterName={samlConstants.NAME_ID_FORMAT}
                              notSpecifiedText={messageConstants.NOT_SPECIFIED}
                              isLocalized={true}
                          />

                          <ListOfParameters
                              id="detailedSpMetadataAcsValues"
                              label={messageConstants.ACS}
                              list={this.props.importedMetadata.assertionConsumerServices}
                              parameterName={samlConstants.ACS_ITEMS}
                              notSpecifiedText={messageConstants.NOT_SPECIFIED}
                          />

                          <ListOfParameters
                              id="detailedSpMetadataSloValues"
                              label={messageConstants.SLO}
                              list={this.props.importedMetadata.singleLogoutServices}
                              parameterName={samlConstants.SLO_ITEMS}
                              notSpecifiedText={messageConstants.NOT_SPECIFIED}
                          />
                        </div>
                    ) : null
              }
            </Modal.Body>
          </Modal>
        </div>
    );
  }

}

export default ViewAllMetadata;
